export function omitNullFields<TValues extends object>(values: TValues): Partial<TValues> {
  return Object.fromEntries(
    Object.entries(values).filter(([, value]) => value !== null),
  ) as Partial<TValues>;
}
